/**
 * Hook useWeather - Récupère et gère les données météo
 */

import { useState, useEffect, useCallback } from 'react';
import weatherService from '../services/weatherService';

export function useWeather() {
  const [weather, setWeather] = useState(null);
  const [dailyInfo, setDailyInfo] = useState([]);
  const [motivation, setMotivation] = useState('');
  const [tip, setTip] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchWeather = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await weatherService.fetchWeather();
      setWeather(data);

      if (data.current?.category) {
        setTip(weatherService.getTip(data.current.category));
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Charger la météo au montage
  useEffect(() => {
    fetchWeather();

    // Rafraîchir toutes les 30 minutes
    const interval = setInterval(fetchWeather, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, [fetchWeather]);

  // Charger les infos du jour
  useEffect(() => {
    setDailyInfo(weatherService.getDailyInfo());
    setMotivation(weatherService.getDailyMotivation());

    // Mettre à jour toutes les heures
    const interval = setInterval(() => {
      setDailyInfo(weatherService.getDailyInfo());
    }, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return {
    weather,
    dailyInfo,
    motivation,
    tip,
    isLoading,
    error,
    refresh: fetchWeather
  };
}

export default useWeather;
